import { END_POINTS, REQUEST_TYPE } from "../lib/variables";
import Api from "./index";

const getAllCategories = (payload) => {
  return Api(END_POINTS.getAllCategories, payload, REQUEST_TYPE.GET);
};

const getAllSubCategories = (idddd) => {
  return Api(
    `${END_POINTS.getAllSubCategories}/${idddd}`,
    null,
    REQUEST_TYPE.GET
  );
};

const getServiceSubCategories = (id, fields = []) => {
  const fieldsParam = fields.length > 0 ? `?fields=${fields.join(",")}` : "";
  return Api(
    `${END_POINTS.getServiceSubCategory}/${id}${fieldsParam}`,
    null,
    REQUEST_TYPE.GET
  );
};

export { getAllCategories, getAllSubCategories, getServiceSubCategories };
